/* unplugin-vue-components disabled */import { render } from "./Batch.vue?vue&type=template&id=65c329da&scoped=true"
import script from "./Batch.vue?vue&type=script&lang=js"
export * from "./Batch.vue?vue&type=script&lang=js"

import "./Batch.vue?vue&type=style&index=0&id=65c329da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c329da"]])

export default __exports__